<template>
  <div>
    <MasterLayout>
      <div class="section__row mt-3">
        <div>
          <b-modal
            ref="my-modal"
            id="modal1"
            hide-footer
            :title="$t('text.iAddOrder.confirmingPayment')"
            v-if="status == loading"
          >
            <div
              class="epump-loader"
              style="top: 22%; left: 35%; width: 120px; height: 120px"
            >
              <img
                src="@/assets/img/epump-logo.png"
                class="epump-loader-logo"
              />
            </div>
          </b-modal>
          <b-modal
            v-if="status == success"
            ref="my-modal"
            id="modal1"
            hide-footer
            :title="$t('text.iAddOrder.paymentConfirmed')"
          >
            <div style="margin: 0 auto; width: 43%; margin-top: 80px" class>
              <div class="success-checkmark">
                <div class="check-icon">
                  <span class="icon-line line-tip"></span>
                  <span class="icon-line line-long"></span>
                  <div class="icon-circle"></div>
                  <div class="icon-fix"></div>
                </div>
              </div>
            </div>
          </b-modal>
          <b-modal
            v-if="status == failure"
            ref="my-modal"
            id="modal1"
            hide-footer
            :title="$t('text.iAddOrder.errorConfirming')"
          >
            <div style="margin: 0 auto; width: 43%">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 130.2 130.2"
                class="cancel_img"
              >
                <circle
                  class="path circle"
                  fill="none"
                  stroke="#D06079"
                  stroke-width="6"
                  stroke-miterlimit="10"
                  cx="65.1"
                  cy="65.1"
                  r="62.1"
                />
                <line
                  class="path line"
                  fill="none"
                  stroke="#D06079"
                  stroke-width="6"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  x1="34.4"
                  y1="37.9"
                  x2="95.8"
                  y2="92.3"
                />
                <line
                  class="path line"
                  fill="none"
                  stroke="#D06079"
                  stroke-width="6"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  x1="95.8"
                  y1="38"
                  x2="34.4"
                  y2="92.2"
                />
              </svg>
            </div>
          </b-modal>
        </div>
      </div>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-12">
                  <div class="progress_container">
                    <div class="order_steps__container">
                      <div class="order_steps__inner_wrapper">
                        <div class="order_progress_step active_outer_circle">
                          <div class="order_progress_step_inner_cirle">
                            <div
                              class="order_progress_step_inner_cirle active_inner"
                            ></div>
                          </div>
                        </div>
                        <h6 class="text-white mt-3">
                          {{ $t("text.iAddOrder.order") }}
                        </h6>
                      </div>
                      <div class="order_steps__inner_wrapper">
                        <div class="order_progress_step" ref="shipping_step">
                          <div
                            class="order_progress_step_inner_cirle"
                            ref="shipping_inner_step"
                          ></div>
                        </div>
                        <h6 class="text-white mt-3">
                          {{ $t("text.iAddOrder.shipping") }}
                        </h6>
                      </div>
                      <div class="order_steps__inner_wrapper">
                        <div class="order_progress_step" ref="paymentStep">
                          <div
                            class="order_progress_step_inner_cirle"
                            ref="payment_inner_step"
                          ></div>
                        </div>
                        <h6 class="text-white mt-3">
                          {{ $t("text.iAddOrder.payment") }}
                        </h6>
                      </div>
                    </div>
                    <div class="progress_track_1"></div>
                    <div class="progress_track_2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="full__row_section mt-3 pb-3">
        <div class="m_wrapper">
          <div class="form_wrapper" v-if="viewStatus === 'order'">
            <div class="text-center">
              <img src="@/assets/img/transportation.svg" width="100px" />
            </div>
            <div class="row mt-4 justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>{{ $t("text.iAddOrder.fullAddress") }}</h6>
              </div>
              <div class="col-md-9">
                <div
                  class="input__block input_width_shrink"
                  style="height: 86px"
                >
                  <textarea
                    type="text"
                    rows="3"
                    v-model="branchAddress"
                    class="form-control input_full_width"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="row mt-5 justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>{{ $t("text.iAddOrder.station") }}</h6>
              </div>
              <div class="col-md-9">
                <div class="input__block input_width_shrink">
                  <input
                    type="text"
                    rows="3"
                    v-model="industryBranchnName"
                    class="form-control input_full_width"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-5 justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>
                  {{ $t("text.iAddOrder.volume") }}({{
                    $t("text.iAddOrder.litres")
                  }})
                </h6>
              </div>
              <div class="col-md-9">
                <div class="input__block input_width_shrink">
                  <input
                    type="number"
                    v-model="volume"
                    :placeholder="$t('text.iAddOrder.volume')"
                    class="form-control input_full_width"
                  />
                </div>
              </div>
            </div>

            <div class="row mt-5 justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>{{ $t("text.iAddOrder.product") }}</h6>
              </div>

              <div class="col-md-9">
                <div class="input__block input_width_shrink">
                  <select v-model="product" @change="prodChange">
                    <option value="select product" disabled>
                      {{ $t("text.iAddOrder.selectAProduct") }}
                    </option>
                    <option
                      :value="prod.productId"
                      v-for="(prod, i) in products"
                      :key="i"
                    >
                      {{ prod.productName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div
              class="row mt-5 justify-content-center align-items-center"
              v-show="prodChange"
            >
              <div class="col-md-3">
                <h6>{{ $t("text.iAddOrder.priceLiter") }}</h6>
              </div>
              <div class="col-md-9">
                <div class="input_width_shrink">
                  {{ pricePerLiter }}
                </div>
              </div>
            </div>

            <div class="row mt-5 justify-content-center align-items-center">
              <div class="col-md-3"></div>
              <div class="col-md-9">
                <div class="text-center mt-4">
                  <button
                    class="vue_router_link btn btn_theme"
                    @click="changeProgrestatus('shipping', 'order')"
                  >
                    {{ $t("text.iAddOrder.continue") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form_wrapper text-left" v-if="viewStatus === 'shipping'">
            <div class="form_container__wrapper">
              <div class="text-center">
                <img src="@/assets/img/transportation.svg" width="100px" />
              </div>
              <div class="row mt-4 justify-content-center align-items-center">
                <div class="col-md-6">
                  <small class="text-black">{{
                    $tc("text.iAddOrder.pricePerLitre", 1)
                  }}</small>
                </div>
                <div class="col-md-6 text-right">
                  <h6>
                    {{ industryBranch ? industryBranch.currencyCode : ""
                    }}{{ pricePerLiter }}
                  </h6>
                </div>
              </div>
              <div class="row mt-4 justify-content-center align-items-center">
                <div class="col-md-6">
                  <small class="text-black">{{
                    $t("text.iAddOrder.amount")
                  }}</small>
                </div>
                <div class="col-md-6 text-right">
                  <h6>
                    <!-- {{ $n(formattedAmount, 'currency') }} -->
                    {{ industryBranch ? industryBranch.currencyCode : "" }}
                    {{ convertThousand(formattedAmount) }}
                  </h6>
                </div>
              </div>
              <div class="row mt-4 justify-content-center align-items-center">
                <div class="col-md-6">
                  <small class="text-black">{{
                    $t("text.iAddOrder.litreVolume")
                  }}</small>
                </div>
                <div class="col-md-6 text-right">
                  <h6>{{ volume }} {{ $t("text.iAddOrder.litres") }}</h6>
                </div>
              </div>
              <div class="row mt-4 justify-content-center align-items-center">
                <div class="col-md-6">
                  <small class="text-black">{{
                    $t("text.iAddOrder.deliveryAddress")
                  }}</small>
                </div>
                <div class="col-md-6 text-right">
                  <h6>{{ branchAddress }}</h6>
                </div>
              </div>
              <div class="row mt-5 justify-content-center align-items-center">
                <div class="text-center mt-4">
                  <button
                    class="vue_router_link btn btn_theme yellow_text mr-2"
                    @click="changeProgrestatus('order', 'shipping')"
                  >
                    {{ $t("text.iAddOrder.previous") }}
                  </button>
                  <button
                    class="vue_router_link btn btn_theme"
                    @click="changeProgrestatus('payment')"
                  >
                    {{ $t("text.iAddOrder.next") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="center_div"
            v-if="viewStatus === 'payment'"
            style="margin-top: 0px"
          >
            <div class="pad_div">
              <ul class="tabs__lists">
                <li
                  class="mt-3"
                  @click="changeTab('wallet')"
                  v-show="balance < totalAmount"
                >
                  <a
                    href="#"
                    class="tab_link"
                    :class="[tab === 'wallet' ? 'active_tab_link' : null]"
                  >
                    <i
                      class="fa fa-credit-card mr-3"
                      aria-hidden="true"
                      :style="[tab === 'wallet' ? { color: '#370F70' } : null]"
                    ></i>
                    {{ $t("text.iAddOrder.bank") }}
                  </a>
                </li>
                <li
                  class="mt-3 ml-5"
                  @click="changeTab('card')"
                  v-show="balance < totalAmount"
                >
                  <a
                    href="#"
                    class="tab_link"
                    :class="[tab === 'card' ? 'active_tab_link' : null]"
                  >
                    <i
                      class="fa fa-credit-card mr-2"
                      aria-hidden="true"
                      :class="[tab == 'card' ? 'primary_text' : null]"
                    ></i>
                    {{ $t("text.iAddOrder.payWithCard") }}
                  </a>
                </li>
              </ul>
            </div>
            <div v-if="tab === 'card'">
              <div class="pay_header_text text-center">
                {{ $t("text.iAddOrder.confirmAmount") }}
              </div>
              <div class="text-center mt-4">
                <img src="@/assets/img/credit-card.svg" width="35px" />
              </div>
              <div class="text-center mt-4">
                <small class="small_text"></small>
              </div>
              <div class="input_holder">
                <div class="mt-4">
                  <input type="hidden" class="email" />
                  <input type="hidden" class="phone" />
                  <input type="hidden" class="publicKey" />
                  <input type="hidden" name="trxRef" class="trxRef" />
                  <input type="hidden" name="flwRef" class="flwRef" />
                  <input
                    type="number"
                    name="amount"
                    :value="totalAmount"
                    class="form-control form__input amount"
                    :placeholder="$t('text.iAddOrder.amount')"
                    style="width: 100%"
                    readonly
                  />
                </div>
              </div>
              <div class="mt-4 text-center">
                <button
                  class="vue_router_link btn btn_theme yellow_text mr-2"
                  @click="changeProgrestatus('shipping', 'payment')"
                >
                  {{ $t("text.iAddOrder.previous") }}
                </button>
                <button class="btn btn_theme" @click="payFunction($event)">
                  {{ $t("text.iAddOrder.payNow") }}
                </button>
              </div>
            </div>

            <!-- <div v-if="tab === 'wallet'">
                    <div
                      class="pay_header_text text-center"
                    >{{$t('text.iAddOrder.walletDebited')}}</div>
                    <div class="text-center mt-4">
                      <img src="@/assets/img/money (3).svg"  width="50" />
                    </div> -->

            <div v-if="tab === 'wallet'">
              <div
                v-show="balance < totalAmount"
                class="pay_header text-center"
              >
                {{ $t("text.iAddOrder.fundWithBank") }}
              </div>
              <div class="text-center mt-4"></div>

              <div class="message text-center mt-3" v-if="dislayInsufficient">
                <p class="text-danger font-weight-bold">
                  {{ $t("text.iAddOrder.availableBalance") }}
                  {{ industryBranch ? industryBranch.currencyCode : ""
                  }}{{ this.balance }}
                </p>
                <p class="font-weight-light mt-3">
                  {{ $t("text.iAddOrder.makeTransfer") }}
                </p>
                <ul class="mt-3 list-group">
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    {{ $t("text.iFundWallet.bankName") }}
                    <span class="text-secondary">
                      {{ $t("text.iFundWallet.providusBank") }}</span
                    >
                  </li>
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    {{ $t("text.iFundWallet.accountNumber") }}
                    <span class="text-secondary">
                      {{ this.accountNumber }}</span
                    >
                  </li>
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span class="text-left">{{
                      $t("text.iFundWallet.accountName")
                    }}</span>
                    <span class="text-secondary text-right">{{
                      this.accountName
                    }}</span>
                  </li>
                  <p class="font-weight-light mt-3">
                    {{ $t("text.iFundWallet.clickContinue") }}
                  </p>
                  <button
                    class="btn btn_theme mt-3"
                    :disabled="isDisabled"
                    @click="maked"
                  >
                    {{ $t("text.iFundWallet.continue") }}
                  </button>
                </ul>
              </div>
              <div>
                <div v-if="latestOrderId !== null">
                  <div
                    class="message text-center mt-3"
                    v-if="!dislayInsufficient"
                  >
                    <div>
                      <p class="list-group-item">
                        OrderID: {{ latestOrderId }}
                      </p>
                      <p class="list-group-item">
                        {{ $t("text.iFundWallet.amount") }}:
                        {{ industryBranch ? industryBranch.currencyCode : ""
                        }}{{ convertThousand(totalAmount) }}
                      </p>
                      <p class="list-group-item">
                        {{ $t("text.iFundWallet.payMode") }}:
                        {{ $t("text.iFundWallet.bWallet") }}
                      </p>
                    </div>
                    <div class="mx-auto text-center" style="width: 400px">
                      <button class="btn btn_theme mt-3" @click="maked">
                        {{ $t("text.iFundWallet.continue") }}
                      </button>
                    </div>
                  </div>
                  <!-- <div class="mx-auto text-center" style="width: 400px">
                    <button class="btn btn_theme mt-3" @click="maked">
                      {{ $t("text.iFundWallet.continue") }}
                    </button>
                  </div> -->
                </div>
                <div
                  class="loader"
                  v-else-if="latestOrderId === null && !dislayInsufficient"
                ></div>
              </div>
            </div>

            <div
              class="pattern_sec"
              :style="[
                {
                  zIndex: '-1200',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundImage: `linear-gradient(rgb(55, 15, 112 , 0.001), rgb(55, 15, 112 ,0.001)), url(${backImg})`,
                },
              ]"
            ></div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import backgroundUrl from "@/assets/img/MobileWallet.png";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Add Order:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      productPrice: 0,
      backImg,
      latestOrderId: null,
      viewStatus: "order",
      dislayInsufficient: false,
      isDisabled: false,
      showLoader: false,
      branchDetails: localStorage.getItem("totalBranches")
        ? JSON.parse(localStorage.getItem("totalBranches"))
        : null,
      industryBranch: null,
      industryBranchId: null,
      balance: 0,
      volume: null,
      products: [],
      product: "select product",
      pricePerLiter: null,
      productValue: null,
      tab: "wallet",
      loading: 0,
      paymentConfirmed: null,
      success: 1,
      failure: 2,
      status: 0,
      backgroundUrl,
      modalWidth: null,
      modalheight: null,
      showBanner: true,
      payOnline: true,
      email: "",
      phone: "",
      publicKey: "",
      banks: null,
      amount: null,
      depositNo: null,
      depositorName: null,
      bank: null,
      showdropDown: false,
      accountName: null,
      accountNumber: null,
      toggleBanksDropdown: false,
      isButtonDisabled: false,
      showButtonLoader: true,
      isFlw: "",
      flwRef: "",
      trxRef: "",
      reservedAccount: null,
      bankName: null,
      startDate: this.$moment().subtract(27, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
    };
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
    });
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        this.getProducts();
        //this.getAccountDetails();
        this.getFundProperties();
        this.getBalance();
      }
    },
  },
  computed: {
    branchAddress() {
      return (
        this.branchDetails[0].street +
        " " +
        "," +
        this.branchDetails[0].city +
        " " +
        "," +
        this.branchDetails[0].state +
        " " +
        "," +
        this.branchDetails[0].country
      );
    },
    industryBranchnName() {
      return this.branchDetails[0].name;
    },
  },
  mounted() {
    if (screen.width <= 575) {
      document
        .querySelector(".padding_div")
        .classList.remove("remove-padding-left");
      document.querySelector(".padding_div").style.marginTop = "15px";
      this.$refs.padding_div.classList.remove("remove-padding-left");
    }
  },
  methods: {
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    maked() {
      this.isDisabled = true;
      let trxRef = Date.now();
      let pricePerLiter = parseFloat(this.pricePerLiter);
      // this.formattedAmount = this.convertThousand(pricePerLiter * this.volume);
      this.formattedAmount = pricePerLiter * this.volume;
      this.totalAmount = parseFloat(pricePerLiter * this.volume);
      //console.log(this.totalAmount)
      // console.log(this.walletBalance)
      if (this.balance > this.totalAmount) {
        this.isFlw = false;
        this.trxRef = trxRef;
        this.flwRef = "";
        this.amount = this.totalAmount.toString();

        this.confirmPayment();
        //this.showModal()
      } else {
        // this.changeTab("card")
        // this.$router.push(`/Industrial/Branch/Dashboard`)
        this.showModal();
        //  this.confirmPayment()
        // this.$router.push(`/Industrial/Branch/Track-Order?id=${this.latestOrderId}`)
      }
    },
    getBalance() {
      this.showLoader = true;
      if (localStorage.getItem("userDetails")) {
        let url = `${configObject.apiBaseUrl}/Branch/branchremiswallet/${this.industryBranch.id}`;
        this.axios
          .get(url, configObject.authConfig())
          .then((res) => {
            this.balance = this.convertThousand(res.data.balance);
            this.accountName = res.data.accountName;
            this.accountNumber = res.data.accountNumber;
          })
          .catch((error) => {
            //  console.log(error.message);
          });
      }
    },
    getOrders() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Orders/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          let orderIDs = [];
          res.data.forEach((el) => {
            orderIDs.push(el.id);
          });
          const latestOrder = Math.max(...orderIDs);
          this.latestOrderId = latestOrder;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    addOrder() {
      const data = {
        quantity: parseFloat(this.volume),
        productId: this.product,
        branchId: this.industryBranchId,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Industrial/Order`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.iAddOrder.successfullyAdded"),
            type: "success",
            duration: 1000,
          });
          this.getOrders();
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.iAddOrder.unsuccessfulAdd"),
            type: "error",
            duration: 3000,
          });
        });
    },
    changeTab(tab) {
      // if(tab === "card") {
      //   this.$launchFlutterwave({
      //     tx_ref: Date.now(),
      //     amount: this.amount,
      //     currency: 'NGN',
      //     payment_options: 'card,mobilemoney,ussd',
      //    customer: {
      //     email: 'user@gmail.com',
      //     phonenumber: '08102909304',
      //     name: 'yemi desola'
      //   },
      //   callback: function(data) {
      //     // specified callback function

      //     console.log(data)
      //   },
      // })

      // }
      this.tab = tab;
    },
    prodChange(event) {
      let pricePerLiter = this.products.filter(
        (prod) => prod.productId == event.target.value
      )[0];
      this.pricePerLiter = this.convertThousand(pricePerLiter.price);
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getProducts() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/peddlingProducts`,
          configObject.authConfig()
        )
        .then((res) => {
          // console.log(res.data[0]);
          this.products = res.data;
          this.productPrice = this.convertThousand(res.data[0].price);
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    randomString(length, chars) {
      var result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    showModal() {
      this.$refs["my-modal"].show();
      setTimeout(() => {
        this.$refs["my-modal"].hide();
        this.$router.push(
          `/Industrial/Branch/Track-Order?id=${this.latestOrderId}`
        );
      }, 3500);
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    confirmPayment() {
      let paymentMode;
      if (this.tab === "wallet") {
        paymentMode = "BranchWallet";
        // this.showModal()
      } else {
        paymentMode = "rave";
      }
      let data = {
        orderId: this.latestOrderId,
        amount: parseFloat(this.amount),
        paymentMode: paymentMode,
        trx_Ref: this.trxRef,
        flw: this.isFlw,
        flwRef: this.flwRef,
      };
      this.$toast.open({
        message: "Your Payment is being confirmed",
        type: "info",
        duration: 3000,
      });
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Industrial/OrderPayment`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          this.showModal();
          this.$toast.open({
            message: this.$t("text.iAddOrder.paymentConfirmed"),
            type: "success",
            duration: 4000,
          });
          this.$refs.paymentStep.classList.add("active_outer_circle");
          this.$refs.payment_inner_step.classList.add("active_inner");
        })
        .catch((error) => {
          this.status = this.failure;
        });
    },
    getFundProperties() {
      this.showBtnLoader = true;
      if (localStorage.getItem("userDetails")) {
        let url = `${configObject.apiBaseUrl}/Wallet/FundProperties`;
        this.axios
          .get(url, configObject.authConfig())
          .then((response) => {
            let user = JSON.parse(localStorage.getItem("userDetails"));
            this.showBtnLoader = false;
            this.email = user.email;
            this.phone = user.phone;
            this.publicKey = response.data.publicKey;
            this.banks = response.data.banks;
          })
          .catch((error) => {});
      }
    },
    generateTransactionRef() {
      var allString = "0123456789";
      var rString = "EP" + this.randomString(14, allString);
      return rString;
    },
    walletPayment($event) {
      $event.preventDefault();
      let tx_ref = this.generateTransactionRef();
      let data = {
        orderId: this.latestOrderId,
        amount: parseFloat(this.totalAmount),
        paymentMode: "BranchWallet",
      };
      $(".loader").show();
      this.isButtonDisabled = true;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Industrial/OrderPayment`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          this.showModal();
          this.$toast.open({
            message: this.$t("text.iAddOrder.paymentConfirmed"),
            type: "success",
            duration: 3000,
          });
          this.$refs.paymentStep.classList.add("active_outer_circle");
          this.$refs.payment_inner_step.classList.add("active_inner");
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.status = this.failure;
          this.showModal();
          $(".loader").hide();
          this.isButtonDisabled = false;
        });
    },
    payFunction(event) {
      event.preventDefault();
      $(".email").val(this.email);
      $(".phone").val(this.phone);
      $(".publicKey").val(this.publicKey);
      var btn = $(this);
      btn.attr("disabled", "disabled");
      var realAmt = parseFloat($(".amount").val());
      if (isFinite(realAmt) && realAmt > 0) {
        //var amt = realAmt + (realAmt * (1.6 / 100));

        var email = $(".email").val();
        var phone = $(".phone").val();
        var pk = $(".publicKey").val(); //"FLWPUBK-fc08788826e348423d0d89eb1370f784-X";//
        var allString = "0123456789";
        var PBFKey = pk;
        var rString = "EP" + this.randomString(14, allString);
        let _this = this;
        let raveSetup = getpaidSetup({
          PBFPubKey: PBFKey,
          customer_email: email,
          customer_firstname: "",
          customer_lastname: "",
          redirect_url:
            "http://test-efueling.epump.com.ng/Industrial/Branch/Order-Management",
          custom_description: "Diesel/LPG Order Payment",
          custom_logo:
            "https://app.epump.com.ng/Content_v3/Images/e-pump%20logo2.png",
          custom_title: "EPUMP",
          amount: realAmt,
          customer_phone: phone,
          country: "NG",
          currency: "NGN",
          payment_method: "both",
          txref: rString,
          //integrity_hash: "<ADD YOUR INTEGRITY HASH HERE>",

          callback: function (response) {
            var flw_ref = response.data.transactionobject.flwRef; // collect flwRef returned and pass to a erver page to complete status check.
            if (response.data.respcode == "00") {
              _this.trxRef = response.data.transactionobject.txRef;
              _this.flwRef = flw_ref;
              _this.amount = realAmt.toString();
              //_this.closeModal();
              _this.isFlw = true;
              _this.confirmPayment();
              // $('.trxRef').val(response.tx.txRef);
              // $('.flwRef').val(flw_ref);
              //$('.onlinePay').submit();

              // redirect to a success page
            } else {
              // redirect to a failure page.
            }
            raveSetup.close();
          },
          onclose: function () {
            btn.removeAttr("disabled");
          },
        });
      } else {
        this.$toast.open({
          message: this.$t("text.iAddOrder.amountMissing"),
          type: "error",
          duration: 2000,
        });
        btn.removeAttr("disabled");
      }
    },

    changeProgrestatus(viewStatus, from) {
      if (this.viewStatus === "order") {
        if (!this.volume) {
          this.$toast.open({
            message: this.$t("text.iAddOrder.volumeMissing"),
            type: "error",
            duration: 3000,
          });
          return;
        }
        if (this.product === "select product") {
          this.$toast.open({
            message: this.$t("text.iAddOrder.productMissing"),
            type: "error",
            duration: 3000,
          });
          return;
        }
      }
      if (viewStatus === "order") {
        this.$refs.shipping_step.classList.remove("active_outer_circle");
        this.$refs.shipping_inner_step.classList.remove("active_inner");

        this.$refs.paymentStep.classList.remove("active_outer_circle");
        this.$refs.payment_inner_step.classList.remove("active_inner");
      }
      if (viewStatus === "shipping") {
        if (from === "order") {
          this.addOrder();
        }
        let pricePerLiter = parseFloat(this.pricePerLiter);
        // this.formattedAmount = this.convertThousand(pricePerLiter * this.volume);
        this.formattedAmount = pricePerLiter * this.volume;
        this.totalAmount = parseFloat(pricePerLiter * this.volume);
        this.$refs.shipping_step.classList.add("active_outer_circle");
        this.$refs.shipping_inner_step.classList.add("active_inner");

        this.$refs.paymentStep.classList.remove("active_outer_circle");
        this.$refs.payment_inner_step.classList.remove("active_inner");
      }
      if (viewStatus === "payment") {
        let pricePerLiter = parseFloat(this.pricePerLiter);
        // this.formattedAmount = this.convertThousand(pricePerLiter * this.volume);
        this.formattedAmount = pricePerLiter * this.volume;
        this.totalAmount = parseFloat(pricePerLiter * this.volume);

        if (this.balance < this.totalAmount) {
          this.dislayInsufficient = true;
        } else if (this.balance > this.totalAmount) {
          this.dislayInsufficient = false;
        }

        // this.$refs.paymentStep.classList.add('active_outer_circle');
        // this.$refs.payment_inner_step.classList.add('active_inner');
      }

      this.viewStatus = viewStatus;
    },
  },
};
</script>

<style scoped>
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #270557; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  position: absolute;
  margin: -76px 0 0 -76px;
  left: 50%;
  top: 50%;
  z-index: 1;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
